import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  notesBox: {
    padding: 16,
    borderRadius: 12,
    background: '#EEF0F2'
  },
  notesList: {
    margin: '8px 0 0',
    paddingLeft: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  acceptRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    marginTop: 12,
    cursor: 'pointer'
  }
});
